import {Injectable} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
    ActionNotificationComponent,
    DeleteEntityDialogComponent,
    FetchEntityDialogComponent,
    UpdateStatusDialogComponent
} from '../../../../views/partials/content/crud';

export enum MessageType {
    Create,
    Read,
    Update,
    Delete
}

@Injectable()
export class LayoutUtilsService {
    /**
     * Service constructor
     */
    constructor(private snackBar: MatSnackBar,
                private dialog: MatDialog) { }

    /**
     * Showing (Mat-Snackbar) Notification
     */
    showActionNotification(
        message: string,
        type = MessageType.Create,
        duration = 10000,
        showCloseButton = true,
        showUndoButton = true,
        undoButtonDuration = 3000,
        verticalPosition: 'top' | 'bottom' = 'bottom'
    ) {
        const data = {
            message,
            snackBar: this.snackBar,
            showCloseButton,
            showUndoButton,
            undoButtonDuration,
            verticalPosition,
            type,
            action: 'Undo'
        };
        return this.snackBar.openFromComponent(ActionNotificationComponent, {
            duration,
            data,
            verticalPosition,
        });
    }

    /**
     * Showing Confirmation (Mat-Dialog) before Entity Removing
     *
     * @param title: stirng
     * @param description: stirng
     * @param waitDesciption: string
     */
    deleteElement(title = '', description = '', waitDesciption = '') {
        return this.dialog.open(DeleteEntityDialogComponent, {
            data: { title, description, waitDesciption },
            width: '440px'
        });
    }

    /**
     * Showing Fetching Window(Mat-Dialog)
     *
     * @param data: any
     */
    fetchElements(data: any) {
        return this.dialog.open(FetchEntityDialogComponent, {
            data,
            width: '400px'
        });
    }

    /**
     * Showing Update Status for Entites Window
     */
    updateStatusForEntities(title: string, statuses: string[], messages: string[]) {
        return this.dialog.open(UpdateStatusDialogComponent, {
            data: { title, statuses, messages },
            width: '480px'
        });
    }
}
